import React, { useState, useEffect } from 'react'
import { BackArrowFeed, CalendarChallengeIcon, ExitChallenge, InfoIconBranding, LocationChallengeIcon, PeopleChallengeIcon, RecognitionWarningIcon, RewardsChallengeIcon, StreakIcon } from '../../utils/icons'
import PropTypes from 'prop-types';
import { TabViewNew } from '../ChallengeDetailsV2/styles';
import {  BottomContainer, ChallengeDetailsConatainer, ChallengeHeading, ChallengesContainer, ColorBox, DateLocationContainer, ImageLayout, LevelConatiner, PointsContainer, MonthlyCalendar, ProgressCard, RightContainer, StreakConatiner, BadgeEarned } from './styles';
import { Border } from '../RecogntionAdmin/styles';
import { CalendarPicker, CalendarWrapper } from '../LogWorkoutCategoryV3/styles';
import Calendar from 'react-calendar';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import HoverButton from '../common/HoverButtonV2';
import CommonModalNew from '../common/CommonModal/CommonModalNew';
import { capitalizeFirstLetter, commaSeperator, convertDateInTimezone, convertMonthFromDate, fetchApi } from '../../utils/methods';
import { toast } from 'react-toastify';
import { ExitMonthlyGoalChallenge, GetMonthlyGoalChallengeDetails, PostAchievementToSocialFeed } from '../../redux/constants/apiConstants';
import { useParams } from 'react-router-dom';
import { ImageUrl } from '../../utils/constants';
import moment from 'moment';
import DailyProgressGraph from './DailyProgressGraph';
import { useLocation } from "react-router-dom";
import SkeletonLoder from '../common/skeletonLoder';
import { showSuccessToast } from './ToastHelper';
import MonthlyChallengeBadgeModal from './MonthlyChallengeBadgeModal';
import { TextContainer } from '../ChallengeDetailsV2/WellnessChallenge/styles';
import dayjs from 'dayjs';
import ToastMessage from '../Manager/ToastMessage';


function MonthlyChallengeDetailsPage({ history }) {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("Challenge");
  const [selectedDate, setSelectedDate] = useState(null);
  const [exitChallengePopup, setExitChallengePopup] = useState(false);
  const [challengeDetails, setChallengeDetails] = useState(null);
  const ActivityType =challengeDetails?.challenge_participants?.challenge_level?.activity_type
  const [isExiting, setIsExiting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showBadgeModal, setShowBadgeModal] = useState(false);
  const location = useLocation();
  const isCompletedTab = location?.state?.completedTab;
  const isCompleted = challengeDetails ? dayjs().isAfter(dayjs(challengeDetails.end_date), 'day') : false;



  useEffect(() => {
    if (id) {
      FetchChallenegesData(id);
    }
  }, [id])


  const FetchChallenegesData = async(challengeId)=>{
    setIsLoading(true);   
    try {
      const res = await fetchApi(GetMonthlyGoalChallengeDetails + "/" + challengeId, "GET");
      if(res.status === 'success'){
        setChallengeDetails(res.data);
        if (res.data?.start_date && isCompletedTab) {
          const firstDay = moment(res.data.start_date).toDate();
          setSelectedDate(firstDay);
        }
        else{
          const today = new Date();
          setSelectedDate(today);
        }
        const challengeIsCompleted = dayjs().isAfter(dayjs(res.data?.end_date), 'day');
        if (challengeIsCompleted && res.data?.challenge_achievement) {
          setShowBadgeModal(true);
        }
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
    finally {
      setIsLoading(false);   // ✅ stop loading
    }
  }


  const SuccessToastEvent = (message) => {
    showSuccessToast(message);
  }

  const handleShareAchievement = async () => {
    try {
      const payload = { achievement_id: challengeDetails?.challenge_achievement?.achievement_id };
      const res = await fetchApi(PostAchievementToSocialFeed, "POST", payload);
      if (res.status === "success") {
        toast(
          <ToastMessage
            title="Personal Daily Goal Challenge!"
            message="Your Step Challenge has been shared successfully On Social Feed!"
          />,
          {
            position: "top-right",
            autoClose: 3000,
            closeButton: false,
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: true,
            zIndex: 900000,
            style: {
              right: "165px",
              top: "46px",
              marginRight: "20px",
              backgroundColor: "transparent",
              boxShadow: "none",
              width: "510px",
            },
          }
        );
        setChallengeDetails((prev) => ({
          ...prev,
          challenge_achievement: { ...prev.challenge_achievement, post_id: res.data?.post_id || 1 }
        }));
        setShowBadgeModal(false);
      } else {
        toast.error(res?.data?.message || "Failed to share achievement");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };


  const joinChallenge = async() => {
    if (isExiting) return; 
    setIsExiting(true);
    const payload = {
      monthly_gaol_challenge_id: id,
    };

    try {
      const res = await fetchApi(ExitMonthlyGoalChallenge, "POST", payload);
      if (res.status === "success") {
        SuccessToastEvent(res?.data?.message);
        // toast.success(res?.data?.message);
        history.push("/portal")
      } else {
        toast.error(res?.data?.message);
        setIsExiting(false);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setIsExiting(false);
    } 
    
    setExitChallengePopup(false);
  };


  const popover = () => (
    <Popover
      id="points-popover"
      className="custom-popover"
    >
      <Popover.Body>
      Thanks for joining. You’ll receive your points <br />
      at the end of the challenge.
      </Popover.Body>
    </Popover>
  );


  const exitChallenge = () => {
    setExitChallengePopup(true);
  }

  const hideExitChallenge = () => {
    setExitChallengePopup(false);
  }


  const getSelectedDateData = () => {
    if (!challengeDetails?.calendar || !selectedDate) return null;
  
    return challengeDetails.calendar.find((item) =>
      moment(item.date).isSame(moment(selectedDate), "day")
    );
  };


  const totalActivity =
  challengeDetails?.challenge_participants?.challenge_level?.total_activity;

  const monthlyTarget =
    challengeDetails?.challenge_participants?.challenge_level?.monthly_target_steps;
  
  const progressPercentage =
  totalActivity && monthlyTarget
    ? Math.min(Math.round((totalActivity / monthlyTarget) * 100), 100)
    : 0;



  

   
  // const rewardPointsPerUnit =
  //   challengeDetails?.reward_points_per_unit; // e.g. 1
  
  // const pointsPerActivityUnit =
  //   challengeDetails?.points_per_activity_unit; // e.g. 1000


  // const earnedPoints =
  // totalActivity && rewardPointsPerUnit && pointsPerActivityUnit
  //   ? Math.floor(
  //     (totalActivity / pointsPerActivityUnit) * rewardPointsPerUnit
  //   )
  //   : 0;

  const Attendees = () => {
    window.console.log("")
    return(
      <div className="rewardBox">
        {PeopleChallengeIcon()}
        <div className="rewardValue">
          {commaSeperator(challengeDetails?.total_participants_count)} Attendees
        </div>
      </div>
    )
  }



  const renderLeftContainer = () => (
    <div className="leftContainer">
      <ChallengeHeading>
        {challengeDetails?.title}
      </ChallengeHeading>
      <ImageLayout>
        <img  src={ImageUrl + "/" + challengeDetails?.image}  alt="Challenge banner"/>
      </ImageLayout>
      <Border margin={"20px 0 "} background={'#EFEFEF'} height={'0.75px'} />
      <div className="AboutHeading">About the challenge</div>
      <div className="des">
        {challengeDetails?.descriptions}
      </div>
      <Border margin={"20px 0 "} background={'#EFEFEF'} height={'0.75px'} />
      <DateLocationContainer>
        <div className="insideBox">
          {CalendarChallengeIcon()}
          <div className="text">
            {convertMonthFromDate(
              moment(convertDateInTimezone(challengeDetails?.start_date)).format("MMMM D")
            )} - {convertMonthFromDate(
              moment(convertDateInTimezone(challengeDetails?.end_date)).format("MMMM D, YYYY")
            )}
          </div>
        </div>
        <div className="insideBox">
          {LocationChallengeIcon()}
          <div className="text">{challengeDetails?.location}</div>
        </div>
      </DateLocationContainer>


      <div style={{ display: "flex" }}>
        {/* Reward Info */}
        {isCompletedTab && challengeDetails?.points_earned_so_far ? (
          <div className="rewardBox">
            {RewardsChallengeIcon()}
            <div className="rewardHeading">
              You Earned +{challengeDetails?.points_earned_so_far} XP
            </div>
          </div>
        ) : !isCompletedTab ? (
          <div className="rewardBox">
            {RewardsChallengeIcon()}
            <div className="rewardValue">
              {challengeDetails?.reward_points_per_unit} XP per{" "}
              {commaSeperator(challengeDetails?.points_per_activity_unit)}{" "}
              {capitalizeFirstLetter(ActivityType)}
            </div>
          </div>
        ) : null}
      
        {/* Attendees always visible */}
        {challengeDetails?.total_participants_count ? <Attendees /> : null}
      </div>

      {isCompleted && challengeDetails?.challenge_achievement?.badge_earned ? <BadgeEarned style={{width:'265px',cursor:'pointer'}} onClick={()=>setShowBadgeModal(true)}>
        <img className="badgeIcon" src={`${ImageUrl}/${challengeDetails?.challenge_achievement?.badge?.badge_icon}`} alt="" />
        <TextContainer isFontSize={"18px"} isLineHeight={"24px"} isFontWeight={"700"}>Badge Earned</TextContainer>
      </BadgeEarned> : null}

     
      {/* <Border margin={"20px 0 "} background={'#EFEFEF'} height={'0.75px'} /> */}
      {/* <BottomContainer>
        <div className="row">
          <div className="boldTexBox">Total Perfect Days - {challengeDetails?.perfect_days}</div>
          <div className="boldTexBox">Total Longest Streak - {challengeDetails?.longest_streak}</div>
        </div>
        <div className="secondRow seconRowMargin">
          <div className="rowContennt">
            <ColorBox />
            <div className="textBox">Completed</div>
          </div>
          <div className="rowContennt">
            <ColorBox isColor="#F6D5D6" />
            <div className="textBox">Not Completed</div>
          </div>
        </div>
        <div className="secondRow">
          <div className="rowContennt">
            <ColorBox isColor="#D3DEF2" />
            <div className="textBox">Today’s Date</div>
          </div>
          <div className="rowContennt">
            <ColorBox isColor="#DCDCDC" />
            <div className="textBox">N/A</div>
          </div>
        </div>
      </BottomContainer> */}

    </div>
  );

  const selectedDayData = getSelectedDateData();
  const selectedDayTotal = selectedDayData?.total || 0;
  const formattedActivityType =
  ActivityType?.charAt(0).toUpperCase() + ActivityType?.slice(1);


  const getProgressColor = (percentage) => {
    if (percentage >= 0 && percentage <= 40) {
      return "#F37A65";
    } else if (percentage >= 41 && percentage <= 70) {
      return "#DA9B6C";
    } else if (percentage >= 71 && percentage <= 100) {
      return "#75B084";
    }
    return "#F37A65";
  };

  const renderRightContainer = () => (
    <div>
      <RightContainer>


        <LevelConatiner style={{ position: "relative" }} isPadding={"8px 16px 0px 16px"}>
          <div className="dateContainer">
            {moment(selectedDate).format("MMM DD, YYYY")}</div>
          <div className="graphContainer">
            <div className="graphContent">
              <DailyProgressGraph
                selectedDate={selectedDate}
                // value={getSelectedDateData()?.total || 0}
                value={selectedDayTotal}
                max={challengeDetails?.challenge_participants?.challenge_level?.daily_goal_steps}
                icon={CalendarChallengeIcon()} // replace with your SVG
                challengeDetails={challengeDetails}
                ActivityType={ActivityType}
              />
            </div>
            <div style={{ marginLeft: "12px" }}>
              <div className="stepsDetails">
                {commaSeperator(selectedDayTotal)} 
              </div>
              <div style={{ fontSize: "16px", color: "#184A61" }}>
                / {commaSeperator(challengeDetails?.challenge_participants?.challenge_level?.daily_goal_steps)} {formattedActivityType}
              </div>
            </div>
          </div>
        </LevelConatiner>

        <div className="statsRow">
          <div className="statBox">
            <div className="label">Daily Average</div>
            <div className="value">{commaSeperator(challengeDetails?.average_daily_goal)} <span className="stepText">{capitalizeFirstLetter(ActivityType)}</span></div>
          </div>
          <div className="statBox">
            <div className="label">Daily Goal</div>
            <div className="value">{commaSeperator(challengeDetails?.challenge_participants?.challenge_level?.daily_goal_steps)} <span className="stepText">{capitalizeFirstLetter(ActivityType)}</span></div>
          </div>
        </div>

        <StreakConatiner>
          <span >{StreakIcon()}</span>
          <div className="streak-details">{challengeDetails?.longest_streak}<span className='streak-text'>{isCompleted ? "Perfect " : null} {challengeDetails?.longest_streak > 1 ? "Days" :"Day"} Streak</span></div>
        </StreakConatiner>
        <LevelConatiner style={{ display: "block" }}>
          <CalendarView />
          <BottomContainer>
            <div className="secondRow seconRowMargin">
              <div className="rowContennt">
                <ColorBox />
                <div className="textBox">Completed</div>
              </div>
              <div className="rowContennt">
                <ColorBox isColor="#FDD2CB" />
                <div className="textBox">Not Completed</div>
              </div>
            </div>
          </BottomContainer>

        </LevelConatiner>
        <LevelConatiner>
          <img className="levelImage" src={ImageUrl + "/" + challengeDetails?.challenge_participants?.challenge_level?.icon}></img>
          <div className="levelName">{challengeDetails?.challenge_participants?.challenge_level?.level_name} Level</div>
        </LevelConatiner>
        <PointsContainer>
          <div className="pointeSection">
            <div className="heading">{isCompletedTab ? "Total Points Earned - " : "Points earned so far - "} <span className="pointValue">{challengeDetails?.points_earned_so_far}XP</span></div>
            {isCompletedTab ? null : <OverlayTrigger placement="bottom" overlay={popover()}  containerPadding={10}
              popperConfig={{ strategy: 'fixed' }}>
              <div className="icon">{InfoIconBranding()}</div>
            </OverlayTrigger>}
          </div>
        </PointsContainer>
        <ProgressCard  isWidth={progressPercentage}   isColor={getProgressColor(progressPercentage)} >
          <div className="progressCard">
            <div className="progressText">Progress - <span className="value">&nbsp;{commaSeperator(totalActivity)} {capitalizeFirstLetter(ActivityType)}</span></div>
            <div className="progressText">Goal -  <span className="value">&nbsp;{commaSeperator(monthlyTarget)} {capitalizeFirstLetter(ActivityType)}</span></div>
          </div>
          <div className="ProgressBar">
            <div className="insideBar"></div>
          </div>
        </ProgressCard>
        {/* <div className="completedColorContainer">
          <div className="heading">Completion Color</div>
          <div className="colorRow">
            <div className="colorItem">
              <div className="firstCircle"></div>
              <div>0 - 40%</div>
            </div>
        
            <div className="colorItem">
              <div className="secondCircle"></div>
              <div>41 - 70%</div>
            </div>
        
            <div className="colorItem">
              <div className="thirdCircle"></div>
              <div>71 - 100%</div>
            </div>
          </div>
        </div> */}
      
      </RightContainer>
    </div>

  );
  


  const CalendarView = () => {
    const isFutureDate = (date) => {
      window.console.log("")
      return moment(date).isAfter(moment(), "day");
    };
       
    const isSameDay = (date1, date2) => {
      window.console.log("")
      return moment(date1).isSame(moment(date2), "day");
    };
       
    const getCalendarStatus = (date) => {
      window.console.log("")
      return challengeDetails?.calendar?.find((item) =>
        moment(item.date).isSame(moment(date), "day")
      );
    };

    const startOfMonth = isCompletedTab ? moment(challengeDetails?.start_date).toDate() : moment().startOf("month").toDate();
    const endOfMonth = isCompletedTab ? moment(challengeDetails?.end_date).toDate() : moment().endOf("month").toDate();


    return(
      <CalendarWrapper>
        <CalendarPicker>
          <MonthlyCalendar>
            <Calendar
              value={selectedDate}
              onChange={setSelectedDate}
              prevLabel={null}
              minDate={startOfMonth}           
              maxDate={endOfMonth}   
              nextLabel={null}
              prev2Label={null}
              navigationLabel={null} 
              next2Label={null}
              formatShortWeekday={(locale, date) =>
                date.toLocaleDateString(locale, { weekday: "short" }).slice(0, 2)
              }
              /* 🎨 COLORS */
              tileClassName={({ date, view }) => {
                if (view !== "month") return null;
                if (isFutureDate(date)) return "future";
                const status = getCalendarStatus(date);
                let className = "";
                // 👇 Only grey future dates when NOT completed tab
                if (!isCompletedTab && isFutureDate(date)) {
                  return "future";
                }
                if (status) {
                  className = status.is_completed ? "completed" : "missed";
                }
                if (selectedDate && isSameDay(date, selectedDate)) {
                  className += " selected";
                }
                return className.trim();
              }}
              tileDisabled={({ date, view }) => {
                if (view !== "month") return false;
                return isFutureDate(date);
              }}
            />
          </MonthlyCalendar>
        </CalendarPicker>
      </CalendarWrapper>
    );}
  



  return (
    <div style={{ maxWidth: "1246px", padding: "24px 0px 40px 0px", margin: "auto", width: "100%" }}>

      {isLoading ?
      
        (<SkeletonLoder width={"100%"} height={"700px"} style={{marginTop:"25px"}}/>)
     
        :
        (<>
          <ChallengesContainer>
            <div className='right-row'>
              <div className="icon"
                onClick={() => {
                  if (isCompletedTab) {
                    history.push({
                      pathname: "/challenges/completed",
                      state: { activeSubTab: "monthly" }
                    });
                  } else {
                    history.push("/portal");
                  }
                }}>
                {BackArrowFeed("#DA6C74")}
              </div>
              <TabViewNew
                width
                padding
                margin={"0px"}
                height="40px"
                active={activeTab == "Challenge" ? 1 : 0}
                onClick={() => setActiveTab("Challenge")}
              >
                {"Challenge"}
              </TabViewNew>
            </div>
            {isCompletedTab ?null : <div className="exit-challenge">
              <HoverButton
                title="Exit Challenge"
                width="20px"
                height="20px"
                svgPath={<ExitChallenge />}
                onClick={() => exitChallenge()}
                backgroundColor="white"
                backgroundColorActive="#DA6C74"
              />
            </div>}
          </ChallengesContainer>
    
          <ChallengeDetailsConatainer>
            <div className="insideConatainer">
              {renderLeftContainer()}
              {renderRightContainer()}
            </div>
          </ChallengeDetailsConatainer>
    
          {showBadgeModal && (
            <MonthlyChallengeBadgeModal
              showModal={showBadgeModal}
              onHide={() => setShowBadgeModal(false)}
              onShare={handleShareAchievement}
              challengeAchievement={challengeDetails?.challenge_achievement}
            />
          )}

          {exitChallengePopup && (<CommonModalNew
            show={exitChallengePopup}
            icon={RecognitionWarningIcon("#CE7841")}
            title="Exit Challenge"
            description="Are you sure you want to exit this challenge?"
            descriptionColor="#CE7841"
            subDescription="This will reset your progress and remove all your challenge activity. This action cannot be undone."
            onCancel={hideExitChallenge}
            onConfirm={() =>joinChallenge()}
            cancelText="Stay in Challenge"
            confirmButtonText="Exit Challenge"
            buttonIcon={ExitChallenge("white")}
            confirmButtonWidth="198px"
            cancelButtonWidth="155px"
            modalHeight="265px"
            isFontSize="16px"
            confirmDisabled={isExiting} 
          />)}
          
        </>
        )}
    </div>
  );
}

MonthlyChallengeDetailsPage.propTypes = {
  history: PropTypes.object.isRequired,
};

export default MonthlyChallengeDetailsPage;
